import * as React from 'react';
import { Col as LibCol, ColProps as LibColProps } from 'react-grid-system';

interface ColProps {
    /**
     * Number of columns this column should occupy at the small breakpoint.
     */
    sm?: LibColProps['sm'];

    /**
     * Number of columns this column should occupy at the medium breakpoint.
     */
    md?: LibColProps['md'];

    /**
     * Number of columns this column should occupy at the large breakpoint.
     */
    lg?: LibColProps['lg'];

    /**
     * Number of columns this column should occupy at the extra-large breakpoint.
     */
    xl?: LibColProps['xl'];

    /**
     * Object the defines the offset at each breakpoint.
     */
    offset?: LibColProps['offset'];

    debug?: LibColProps['debug'];
    order?: LibColProps['order'];
    push?: LibColProps['push'];
    pull?: LibColProps['pull'];
    style?: LibColProps['style'];
    component?: LibColProps['component'];
    ref?: LibColProps['ref'];
}

export const Col: React.FunctionComponent<React.PropsWithChildren<ColProps>> = (props) => {
    // Set the default to a fixed width of one column, instead of the parent library default which is auto-width.
    const { sm = 1, md = sm, lg = md, xl = lg, ref, children, ...rest } = props;
    return (
        <LibCol
            xs={sm}
            sm={sm}
            md={md}
            lg={lg}
            xl={xl}
            ref={ref as React.LegacyRef<LibCol> & React.LegacyRef<HTMLDivElement>}
            {...rest}
        >
            {children}
        </LibCol>
    );
};
